import React from "react";
import CustomBootstrapModal from "./customBootstrapModal";
import { useSelfUser } from "../reducers/accounts/user";
import { FullAddressWithName } from "./fullAddresswithName";

const BranchSelector = ({
  show,
  setShow,
  selectedBranch,
  setSelectedBranch,
  multiselect = false,
}) => {
  const { user } = useSelfUser();

  // Flatten parent + child branches into one array
  const branches =
    user?.organizations?.flatMap((org) => {
      const parentBranch = {
        id: org.id,
        name: org.name,
        address: org.address,
      };

      const children =
        org?.children?.map((child) => ({
          id: child.id,
          name: child.name,
          address: child.address,
        })) || [];

      return [parentBranch, ...children];
    }) || [];

  const isSelected = (branch) => {
    if (multiselect) return selectedBranch?.some((b) => b.id === branch.id);
    return selectedBranch?.id === branch.id;
  };

  const handleSelectBranch = (e, branch) => {
    const isChecked = e.target.checked;

    if (multiselect) {
      setSelectedBranch((prev = []) => {
        if (isChecked) {
          // Add to array if not already present
          const exists = prev.some((b) => b.id === branch.id);
          return exists ? prev : [...prev, branch];
        } else {
          // Remove from array
          return prev.filter((b) => b.id !== branch.id);
        }
      });
    } else {
      if (isChecked) {
        setSelectedBranch(branch);
        setShow(false);
      }
    }
  };

  return (
    <CustomBootstrapModal
      show={show}
      setShow={setShow}
      title="Select Branch"
      onClose={() => setShow(false)}
      onSave={handleSelectBranch}
      hasFooter={false}
    >
      <form>
        {branches.map((branch) => (
          <div className="form-check mb-2" key={branch.id}>
            <input
              className="form-check-input"
              type={multiselect ? "checkbox" : "radio"}
              name="branch"
              id={`branch-${branch.id}`}
              value={branch.id}
              checked={isSelected(branch)}
              onChange={(e) => handleSelectBranch(e, branch)}
            />
            <label className="form-check-label" htmlFor={`branch-${branch.id}`}>
              {branch.name}
              {branch.address && branch.address?.pincode && (
                <div className="text-muted small">
                  <FullAddressWithName
                    address={branch.address}
                    includeName={false}
                  />
                </div>
              )}
            </label>
          </div>
        ))}
      </form>
    </CustomBootstrapModal>
  );
};

export default BranchSelector;
